import { render, staticRenderFns } from "./List-Shipment-Bag.vue?vue&type=template&id=17dd1525"
import script from "./List-Shipment-Bag.vue?vue&type=script&lang=js"
export * from "./List-Shipment-Bag.vue?vue&type=script&lang=js"
import style0 from "./List-Shipment-Bag.vue?vue&type=style&index=0&id=17dd1525&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports